module.exports = __webpack_public_path__ + "img/location-cn.c4ed7996.png";